export default __webpack_public_path__ + "static/media/Pause.74df2772.svg";